import { useQuery } from "@tanstack/react-query";
import { CMSBundle, CMSBundleDTO, SalesforceBundle } from "~/api/models/Bundle";
import { QueryKeys } from "~/queryKeys";
import {
  storyblokRoutes,
  storyblokServiceSingleton,
} from "~/services/storyblok";
import { useLocaleStore } from "~/stores/locale/useLocaleStore";

export const useFetchBundleFromCms = (bundle?: SalesforceBundle | null) => {
  const { locale } = useLocaleStore();

  const productCodeResult = useQuery({
    queryKey: [QueryKeys.useFetchBundles, bundle?.productCode, locale],
    queryFn: () =>
      storyblokServiceSingleton.get<CMSBundleDTO>(
        `${storyblokRoutes.bundles}/${bundle?.productCode}`,
        {
          locale,
        }
      ),
    enabled: !!bundle?.productCode,
  });

  const groupResult = useQuery({
    queryKey: [QueryKeys.useFetchBundles, bundle?.group, locale],
    queryFn: () =>
      storyblokServiceSingleton.get<CMSBundleDTO>(
        `${storyblokRoutes.bundles}/${bundle?.group}`,
        {
          locale,
        }
      ),
    enabled: !!bundle?.group && !productCodeResult.data?.data?.stories?.length,
  });

  const productCodeDTO = productCodeResult.data?.data?.stories.length
    ? productCodeResult.data?.data?.stories[0]?.content
    : undefined;

  const groupDTO = groupResult.data?.data?.stories.length
    ? groupResult.data?.data?.stories[0]?.content
    : undefined;

  const bundleDTO = productCodeDTO || groupDTO;

  if (!bundleDTO)
    return {
      ...productCodeResult,
      data: null,
    };

  return {
    ...productCodeResult,
    data: new CMSBundle(bundleDTO),
  };
};
